import { useEffect, useState } from "react";

interface GameProgressProps {
  progress: number;
  status: string;
}

const GameProgress = ({ progress, status }: GameProgressProps) => {
  const [currentProgress, setCurrentProgress] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentProgress(progress);
    }, 100);
    return () => clearTimeout(timer);
  }, [progress]);

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <p className="text-sm font-mono text-muted-foreground">
          <span className="text-accent">{'>> '}</span>ПРОГРЕСС РАЗРАБОТКИ
        </p>
        <p className="text-2xl font-cyber font-bold text-primary">{currentProgress}%</p>
      </div>
      
      <div className="h-4 bg-background/50 border border-primary/30 overflow-hidden relative">
        <div
          className="h-full bg-gradient-to-r from-primary via-accent to-secondary relative overflow-hidden transition-all duration-1000"
          style={{ width: `${currentProgress}%` }}
        >
          <div className="absolute inset-0 bg-white/20 animate-pulse" />
        </div>
        
        {/* Segments */}
        <div className="absolute inset-0 flex">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className="flex-1 border-r border-background/50 last:border-r-0" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default GameProgress;
